import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const WidgetContact = () => {
    const { t } = useTranslation();
    const [isContentVisible, setIsContentVisible] = useState(false);

    const toggleContentVisibility = () => {
        setIsContentVisible(!isContentVisible);
    };

    return (
        <div className="fixed bottom-4 right-4 z-50">
            {/* Contenu visible uniquement si ouvert */}
            {isContentVisible && (
                <div className="bg-secondary p-4 rounded-xl shadow-lg max-w-xs transition-all duration-300 relative border border-[#151f3d]">
                    <div className="space-y-2">
                        <h3 className="text-white text-lg font-semibold">{t('contact.title') || 'Contactez-nous'}</h3>
                        <div className="text-white text-sm space-y-2">
                            <div className="flex items-center gap-2">
                                <FontAwesomeIcon icon={faPhone} />
                                <a href="tel:+33387885670" className="hover:underline hover:text-gray-200 transition">
                                    +33 (0)3 87 88 56 70
                                </a>
                            </div>
                            <div className="flex items-center gap-2">
                                <FontAwesomeIcon icon={faEnvelope} />
                                <a href="mailto:info@fiskagroup.com" className="hover:underline hover:text-gray-200 transition">
                                    info@fiskagroup.com
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Flèche pour refermer */}
                    <button
                        onClick={toggleContentVisibility}
                        className="z-[999px] absolute -top-3 -right-3 bg-main text-white p-2 rounded-full shadow hover:scale-110 transition-transform"
                        aria-label={t('contact.close') || 'Fermer le contact'}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 8.586L4.707 3.293A1 1 0 103.293 4.707L8.586 10l-5.293 5.293a1 1 0 101.414 1.414L10 11.414l5.293 5.293a1 1 0 001.414-1.414L11.414 10l5.293-5.293a1 1 0 10-1.414-1.414L10 8.586z" clipRule="evenodd" />
                        </svg>
                    </button>
                </div>
            )}

            {/* Bouton bulle visible si fermé */}
            {!isContentVisible && (
                <button
                    onClick={toggleContentVisibility}
                    className="flex items-center gap-2 bg-main text-white px-4 py-2 rounded-full shadow hover:scale-105 transition-transform"
                    aria-label={t('contact.open') || 'Ouvrir le contact'}
                >
                    <FontAwesomeIcon icon={faComments} className="text-lg" />
                    <span className="text-sm font-medium">{t('contact.bubbleText') || 'Avez-vous besoin d’aide ?'}</span>
                </button>
            )}
        </div>
    );
};

export default WidgetContact;